module.exports = __webpack_public_path__ + "static/media/c8d605ac11d6844027db62645ce653650_38264845_201027_5.82867390.jpg";